import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EditorImg from 'lowcode/components/EditorImg';
import { Navigation } from 'swiper';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { EU_LIST } from '@/components/XPower/constants';
import getLocal from '@/app/utils/getLocal';

const Third: FC = () => {
    const { t } = useLang('xcode.xfusion.third');
    const { locale } = getLocal();

    const mediaList = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718076441604/section1.png',
            h5url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718076739727/section1%20(4).png',
        },

        {
            title: t('item2_title'),
            desc: t.rich('item2_desc', {
                line: (text: string) => <span>{text}</span>,
            }),
            url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951285686/PC%E5%85%A8%E5%B9%B3%E5%8F%B0.png',
            h5url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951329899/%E7%A7%BB%E5%8A%A8%E7%AB%AF%E5%85%A8%E5%B9%B3%E5%8F%B0.jpg',
        },
        {
            title: t('item3_title'),
            desc: t.rich('item3_desc', {
                line: (text: string) => <span>{text}</span>,
            }),
            url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718076506465/section1%20(2).png',
            h5url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718076805112/section1%20(1).png',
        },
        {
            title: t('item4_title'),
            desc: t.rich('item4_desc', {
                line: (text: string) => <span>{text}</span>,
            }),
            url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719300697687/TOU-web%20(1).png',
            h5url: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719300653374/Tou-%E7%A7%BB%E5%8A%A8%E7%AB%AF%20(1).jpg',
        },
    ];

    if (EU_LIST.includes(locale)) {
        mediaList.pop();
    }

    return (
        <div className={styled.Third}>
            <div className="media_box">
                <div className="middle-central header">
                    {/* <OasisIcon /> */}
                    <p className="oasis">Oasis</p>
                    <p className="title">{t('title')}</p>
                </div>
                {/* pc样式 */}
                <div className="pc">
                    <Swiper
                        className="media_swiper"
                        modules={[Navigation]}
                        spaceBetween={30}
                        navigation
                        // centeredSlides={true}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 32,
                            snapOnRelease: true,
                        }}
                    >
                        {mediaList?.map((item, index) => (
                            <SwiperSlide className="item" key={index}>
                                <div className="left_text">
                                    <p className="item_title">{item.title}</p>
                                    <p className="item_desc">{item.desc}</p>
                                </div>
                                <div className="media">
                                    <EditorImg pc={item.url} alt={item.url} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                {/* mobile样式 */}
                <div className="mobile">
                    {mediaList?.map((item, index) => (
                        <div className="media_item" key={index}>
                            <div className="big-central">
                                <EditorImg pc={item.h5url} alt={item.url} />
                            </div>
                            <div className="middle-central">
                                <p className="item_title">{item.title}</p>
                                <p className="item_desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Third;
